import { requestJson, requestBlob, assertOk} from "./storeApi"


export async function fetchCustomers() {
    const { response, payload } = await requestJson("/customers", {
        method: "GET",
        credentials: "include",
    });
    return assertOk(response, payload, "Failed to load customers");
}

export async function getAppointmentHistory(customerID) {
    const { response, payload } = await requestJson(`/customers/appointmentHistory/${customerID}`, {
        method: "GET",
        credentials: "include",
    });
    return assertOk(response, payload, "Failed to load appointment history");
}

export async function fetchAppointmentTransactions() {
    const { response, payload } = await requestJson("/appointments/transactions");
    return assertOk(response, payload, "Failed to load transactions");
}

export async function fetchAppointmentReceipt(appointmentId) {
    return requestBlob(`/payments/receipt/${appointmentId}`, "Failed to load receipt");
}